import React from "react";
import "./licensedTemplate.scss";
import PageTitle from "componets/molecules/PageTitle/pageTitle";
import imgSrc from "../../../bgImages/home.JPG";
import PersonalFooter from "componets/organisms/personalFooter/personalFooter";
import ResearchText from "componets/atoms/researchText/researchText";
import ResearchCard from "componets/molecules/researchCard/researchCard";

const LicensedTemplate = ({ contentData }) => {
  const pageData = contentData[0];
  const graduates = contentData[1];
  const breadcrumsData = [
    { text: "Inicio", link: "/" },
    { text: "Extensión", link: "/extension" },
    { text: "Diplomados", link: "/diplomados" },
  ];
  return (
    <div className="licensed-template__main-container">
      <>
        {!contentData ? (
          <p>Un momento, mientras la información se carga</p>
        ) : (
          <>
            <PageTitle
              type="right"
              imgSrc={imgSrc}
              breadData={breadcrumsData}
              data={{
                title: pageData.header.titulo,
                subtitle: pageData.header.subtitulo,
                description: pageData.header.descripcion,
              }}
            />

            <div className="licensed-template__card-section">
              {graduates.map((extCard, index) => (
                <div key={index} className="licensed-template__card">
                  <ResearchCard
                    image={extCard.imgURL}
                    title={extCard.titulo}
                    subtitle={extCard.type}
                    color={extCard.color}
                    url={extCard.url}
                  />
                </div>
              ))}
            </div>

            <PersonalFooter textSize={1} />
          </>
        )}
      </>
    </div>
  );
};

export default LicensedTemplate;
